export const AdminUnqualifiedLeadsPermissions = {
  AdminUnqualifiedLeadsPermissions: {
    permissionsId: "d0d9a9a7-7505-4e47-f94c-08dc0f48c1d2",
    permissionsName: "Unqualified Leads Dashboard",
    description: null,
    componentsId: null,
    components: null
  },
};
